module.exports = __webpack_public_path__ + "static/coast-site-70809dbe2ab7320b43324832e75de0c2.jpg";